document.addEventListener('DOMContentLoaded', function() {
  const searchButtons = document.querySelectorAll('.js-header-drawer-toggler[data-target="headerDrawerSearch"]');
  const searchDrawer = document.getElementById('headerDrawerSearch');
  
  if (searchButtons.length && searchDrawer) {
    console.log('Search toggle initialized');
    
    searchButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Stop other event listeners
        
        console.log('=== BEFORE TOGGLE ===');
        console.log('Display:', searchDrawer.style.display);
        console.log('Has is-active:', searchDrawer.classList.contains('is-active'));
        
        // Simple toggle - if it's visible, hide it; if hidden, show it
        const currentDisplay = window.getComputedStyle(searchDrawer).display;
        
        if (currentDisplay !== 'none') {
          // It's visible, so close it
          searchDrawer.style.display = 'none';
          searchDrawer.classList.remove('is-active');
          searchButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
          console.log('CLOSING');
        } else {
          // It's hidden, so open it
          searchDrawer.style.display = 'block';
          searchDrawer.classList.add('is-active');
          searchButtons.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
          
          const searchInput = searchDrawer.querySelector('.js-predictive-search-input');
          if (searchInput) {
            setTimeout(() => searchInput.focus(), 100);
          }
          console.log('OPENING');
        }
        
        console.log('=== AFTER TOGGLE ===');
        console.log('Display:', searchDrawer.style.display);
        console.log('Has is-active:', searchDrawer.classList.contains('is-active'));
        
      }, true); // Use capture phase to run before other listeners
    });
    
    // Close search when clicking outside
    document.addEventListener('click', function(e) {
      const currentDisplay = window.getComputedStyle(searchDrawer).display;
      
      // Check if search is open
      if (currentDisplay !== 'none') {
        // Check if click is outside the search drawer
        const isClickInside = searchDrawer.contains(e.target);
        
        // Check if click is on a toggle button
        const isToggleButton = e.target.closest('.js-header-drawer-toggler[data-target="headerDrawerSearch"]');
        
        // If click is outside and not on toggle button, close the search
        if (!isClickInside && !isToggleButton) {
          console.log('Click outside detected - closing search');
          searchDrawer.style.display = 'none';
          searchDrawer.classList.remove('is-active');
          searchButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
        }
      }
    });
    
  } else {
    console.log('Buttons or drawer not found!');
  }
});

function renderResult(responseText, resultContainer, applyButton) {
  clearInnerResults(resultContainer);
  
  // Show the result container
  resultContainer.style.display = 'block'; // Add this line
  
  applyButton.removeAttribute(attributes.disabled);
  applyButton.removeAttribute(attributes.ariaHidden);
  
  const result = responseText.querySelector(selectors.resultWrapper);
  if (!result) {
    applyButton.setAttribute(attributes.disabled, attributes.disabled);
    applyButton.setAttribute(attributes.ariaHidden, "true");
    renderEmptyResult(resultContainer);
    return;
  }
  resultContainer.innerHTML = result.innerHTML;
  document.addEventListener("click", setActiveTabCategory);
}

function resetAction() {
  const applyButton = document.querySelector(selectors.applyButton);
  const resultContainer = document.querySelector(selectors.resultContainer);
  
  applyButton.setAttribute(attributes.disabled, attributes.disabled);
  applyButton.setAttribute(attributes.ariaHidden, "true");
  clearInnerResults(resultContainer);
  resultContainer.innerHTML = defaultResult;
  resultContainer.style.display = 'none'; // Add this line
  footer.classList.add(classes.hidden);
}